var _path, _path2, _path3, _path4, _polygon, _polygon2, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 207.2 57.1",
    style: {
      enableBackground: "new 0 0 207.2 57.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13,1.2c-3.5,0-6.5,3-6.5,6.5s2.9,6.5,6.5,6.5c3.5,0,6.5-3,6.5-6.5S16.5,1.2,13,1.2z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M43.9,18.4c-4.7,0-8.3,1.7-10.3,4.4v-3.4H22.7v36.3h10.9V35.9c0-5.2,2.7-7.5,6.7-7.5c3.5,0,6.3,2.1,6.3,6.6 v20.6h10.9V33.4C57.5,23.6,51.2,18.4,43.9,18.4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M88.4,22.8c-2.4-2.7-6-4.4-10.8-4.4c-9.5,0-17.3,8.3-17.3,19.1c0,10.8,7.8,19.1,17.3,19.1 c4.9,0,8.4-1.7,10.8-4.4v3.4h10.8V5H88.4V22.8z M79.8,46.3c-5,0-8.6-3.4-8.6-8.8c0-5.4,3.6-8.8,8.6-8.8s8.6,3.4,8.6,8.8 C88.4,42.9,84.7,46.3,79.8,46.3z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M128.8,44.2c-1.4,1.5-3.9,2.7-6.9,2.7c-4,0-7.3-1.3-8.7-5h25.7c0.3-1.3,0.4-2.8,0.4-4.3 c0-10.9-7.8-19.1-18.4-19.1c-11.4,0-19.2,8.3-19.2,19.1s7.6,19.1,20,19.1c6.9,0,12.3-2.6,15.8-7.5L128.8,44.2z M120.9,28.1 c3.3,0,6.5,1.5,7.7,5.7H113C114,30.1,116.8,28.1,120.9,28.1z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "174.4,19.4 162,19.4 155.7,28.4 149.4,19.4 137,19.4 149.6,37.2 136.6,55.6 149,55.6 155.7,46  162.4,55.6 174.9,55.6 161.9,37.2  "
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "18,19 1,19 1,29 7.5,29 7.5,55.6 18.4,55.6 18.4,19.4 18,19.4  "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 178,
    y: 48,
    className: "st0",
    width: 28,
    height: 8
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9131f74486e37c49f8166655431497bd.svg";
export { ForwardRef as ReactComponent };